var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFavouriteHs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "45px",
    viewBox: "0 0 46 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFavouriteHS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.9482491,19.94836 C45.8526091,19.067 46.1718491,17.77348 45.7817691,16.57104 C45.3907691,15.3686 44.3723291,14.51024 43.1211291,14.32808 L31.9964891,12.71164 C31.5226891,12.64264 31.1132891,12.34548 30.9016891,11.91584 L25.9281691,1.83632 C25.3697291,0.7038 24.2362891,0 22.9731291,0 C21.7108891,0 20.5774491,0.7038 20.0190091,1.83632 L15.0445691,11.91676 C14.8329691,12.3464 14.4226491,12.64356 13.9488491,12.71256 L2.82420908,14.329 C1.57392908,14.51024 0.55456908,15.36952 0.16356908,16.57196 C-0.22651092,17.7744 0.0927290804,19.06792 0.99708908,19.94928 L9.04616908,27.79504 C9.38932908,28.12992 9.54664908,28.612 9.46568908,29.08304 L7.56680908,40.16168 C7.39844908,41.13688 7.65420908,42.0854 8.28532908,42.83336 C9.26604908,43.999 10.9781691,44.35412 12.3471291,43.63468 L22.2960091,38.40356 C22.7118491,38.18552 23.2353291,38.18736 23.6502491,38.40356 L33.6000491,43.63468 C34.0839691,43.88952 34.6000891,44.01832 35.1327691,44.01832 C36.1052091,44.01832 37.0270491,43.58592 37.6609291,42.83336 C38.2929691,42.0854 38.5478091,41.13504 38.3794491,40.16168 L36.4796491,29.08304 C36.3986891,28.61108 36.5560091,28.12992 36.8991691,27.79504 L44.9482491,19.94836 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final",
    transform: "translate(-481.000000, -1789.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LeftSide-Bar",
    transform: "translate(358.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-V2",
    transform: "translate(0.000000, 528.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-Fav's---Emp-state",
    transform: "translate(0.000000, 996.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects---Views"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-matches-yet",
    transform: "translate(99.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/white",
    transform: "translate(24.000000, 0.920000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icFavouriteHS",
    fill: "#CECECE",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFavouriteHs);
export default __webpack_public_path__ + "static/media/icFavouriteHS.5bd7cb00a979680a47a70af33059634c.svg";
export { ForwardRef as ReactComponent };